const SKIN_TONE_MAP = {
    Pale: "very light",
    Fair: "light",
    Light: "light medium",
    Medium: "medium",
    Olive: "medium brown",
    Brown: "brown",
    Dark: "dark brown",
};

const ETHNICITY_MAP = {
    indian: "Indian",
    asian: "Asian",
    "south asian": "south Asian",
    caucasian: "Caucasian",
    african: "African",
    latino: "latino",
    middle_eastern: "middle eastern",
    native_american: "native American",
};

const ACCESSORY_KEY_MAP = {
    "gold chain": "gold_chain",
};

function normalizeColor(value) {
    return value ? value.toLowerCase() : undefined;
}

function normalizeAccessories(accessories = {}) {
    const out = {};
    Object.entries(accessories).forEach(([key, value]) => {
        if (!value) return;
        const safeKey = ACCESSORY_KEY_MAP[key] || key;
        out[safeKey] = true;
    });
    return Object.keys(out).length > 0 ? out : undefined;
}

export function mapPersonConfigToPayload(config) {
    return {
        size: config.size,
        num_images: 1,

        age: config.age,
        gender: config.gender,

        ethnicity: ETHNICITY_MAP[config.ethnicity] || undefined,
        skin_tone: SKIN_TONE_MAP[config.skin_tone] || undefined,

        eye_color: normalizeColor(config.eye_color),

        hair_length: config.hair_length,
        hair_style: config.hair_style,
        hair_color: normalizeColor(config.hair_color),

        cloth_style: config.cloth_style,
        cloth_color: normalizeColor(config.cloth_color),

        shot_type: config.shot_type,
        pose: config.pose,
        expression: config.expression,

        accessories: normalizeAccessories(config.accessories),

        reference_image: config.reference_image || undefined,
    };
}
